<template>
  <div class="empty-page" flex="main:center cross:center dir:top">
    <img v-if="type === 1" class="pic" src="https://oss.mifengbangzu.com/web/clear.png?x-oss-process=image/resize,p_30" />
    <img v-else-if="type === 2" class="pic" src="https://oss.mifengbangzu.com/web/network_error.png?x-oss-process=image/resize,p_30" />
    <div flex="main:center cross:center" style="color: #999;">{{titleText}} <span v-if="btnText" class="btn" @click="$emit('handleBtn')">{{btnText}}</span></div>
    <div v-if="type === 2"  class="load-btn" @click="$emit('reloadCallback')">重新加载</div>
  </div>
</template>
<script>
	export default {
    name: 'emptyView',
    data() {
      return {
        focus: false,
      }
    },
    props: {
	    title: {
	    	type: String,
		    default: ''
      },
      btnText: {
        type: String,
        default: ''
      },
      type: { // type: 1 空页面， 2：网络错误页
        type: Number,
        default: 1,
      },
    },
    computed: {
		  titleText () {
		    console.log(this.type)
		    if (this.type === 2) {
		      return '网络不给力'
        } else {
		      return this.title
        }
      }
    }
	}
</script>
<style lang="scss" scoped>
  .empty-page {
    width: 100%;
    min-height: 70vh;
    height: 100%;
    max-height: 100%;
    font-size: 0.28rem;
  }
  .pic {
    margin-bottom: 0.2rem;
    width: 0.96rem;
  }
  .load-btn {
    width: 2.26rem;
    height: 0.76rem;
    background:#BD151D;
    border-radius: 4px;
    font-size: 0.34rem;
    color: #fff;
    line-height: 0.76rem;
    text-align: center;
    margin-top: 0.44rem;
  }
  .btn {
    background: #BD151D;
    color: #fff;
    padding: 0.05rem 0.2rem;
    margin-left: 0.1rem;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EmptyView/index.vue